<!--用户档案-->
<template>
  <div class="myTree" v-loading="layerOut" element-loading-text="正在导出">
    <div
      class="ff-tree-hidden-show"
      @click="treeShow = !treeShow"
      :title="treeShow? '收起树' : '显示树'"
      :class="{'ff-tree-treeShow': !treeShow}"
    >
      <i class="iconfont" v-show="!treeShow">&#xe611;</i>
      <i class="iconfont" v-show="treeShow">&#xe610;</i>
    </div>
    <div class="leftHao" :class="{'ff-tree-control': !treeShow,'ff-tree-control-show': treeShow}">
      <el-input placeholder="请输入机构编号或名称" v-model="search" @keyup.enter.native="searchNode">
        <i class="el-icon-search el-input__icon" slot="suffix" @click="handleIconClick"></i>
      </el-input>
      <div class="leftTree">
        <my-tree v-on:getItemData="getItemData" :list="list" :search="search"></my-tree>
      </div>
    </div>
    <div
      class="LineBetween"
      :class="{'ff-left-translate': !treeShow,'ff-right-translate': treeShow}"
    ></div>
    <div class="rightTable">
      <mytable class="mytable" ref="mytable"></mytable>
    </div>

    <!-- 弹框报错信息 -->
    <tips-dialog
      v-if="tipsDialog.show"
      :title="tipsDialog.title"
      :visible.sync="tipsDialog.show"
      :showClose="true"
      :close-on-click-modal="false"
      class="tipsDialog"
      :class="tipsDialog.type"
    >
      <error-tips
        :hiddenButton="tipsDialog.hiddenButton"
        :errorMessage="tipsDialog.errorList"
        :DialogBack="tipsDialog.backBtn"
        :DialogClass="tipsDialog.type"
        v-on:refreshbizlines="errorDialogClose"
      ></error-tips>
    </tips-dialog>
  </div>
</template>

<script>
//用户档案
// import myTree from "../../components/tree/tree2.vue"
// import mytable from "../manage/table.vue"
// import axios from 'axios'
// import errorTips from '../../components/tablelist/error'
// import tipsDialog from '../../components/dialog/mydialog'

export default {
  data() {
    return {
      treeShow: true,
      tipsDialog: {
        title: "错误提示",
        action: "",
        show: false,
        errorList: [],
        type: "",
        name: "",
        hiddenButton: false,
        backBtn: false //是否有返回按钮
      }, //报错参数
      obj: {}, //传给table的对象
      layerOut: false, //蒙层

      search: "", //搜索框输入值
      saveObj: {}, //存储的每次节点的对象
      treeNodes: [], //树的所有节点的数据
      treeShow: true,
      list: [], //传给树组件的数组
      //  changeList: {
      //      list: []
      //  },
      treeData: [
        { id: 1, pid: 0, name: "1" },
        { id: 2, pid: 4, name: "2[父4]" },
        { id: 3, pid: 7, name: "3[父7]" },
        { id: 4, pid: 1, name: "4[父1]" },
        { id: 5, pid: 6, name: "5[父6]" },
        { id: 6, pid: 0, name: "6" },
        { id: 7, pid: 4, name: "7[父4]" },
        { id: 8, pid: 6, name: "8[父6]" },
        { id: 9, pid: 0, name: "9" },
        { id: 10, pid: 6, name: "10[父6]" }
      ], // 请求回来的初始data

      // arrayList:[],//把匹配到item 存放这个数组
      ztreeDataSource: [] //请求回来的初始data
    };
  },

  mounted() {
    this.getCstoreorgload();
    // console.log(this.$refs);
  },

  // components: {
  //   myTree,
  //   mytable,
  //   errorTips,
  //   tipsDialog
  // },
  methods: {
    exportLoading(value) {
      this.layerOut = value;
    }, //导出
    //报错方法
    errorMessage(msg) {
      let self = this;
      let data = {
        message: msg.isAction ? msg.desc : "确认执行" + msg.title + "?"
      };
      self.tipsDialog.show = true;
      self.tipsDialog.action = msg.action;
      self.tipsDialog.type = msg.type;
      self.tipsDialog.title = "错误";
      self.tipsDialog.name = msg.title;
      self.tipsDialog.errorList = data;
      self.tipsDialog.backBtn = true;
      self.tipsDialog.hiddenButton = true;
    },
    //点击确定按钮触发
    errorDialogClose() {
      this.tipsDialog.show = !this.tipsDialog.show;
    },
    //表格返回时的状态
    getTableWay(bo) {
      // this.getCstoreorgload();
      // console.log(this.saveObj.ID)
      let self = this;
      let num = 0;
      let sendObj = {}; //存储传给table的对象

      this.$ajax.dataAjax(
        "/p/cs/userstreeload",
        {},
        // async: false,
        function(res) {
          res = JSON.parse(JSON.stringify(res));
          if (res.code === 0) {
            // 储存原始数据以便后续模糊查询使用
            self.ztreeDataSource = JSON.parse(JSON.stringify(res.data));
            //储存渲染树的数据
            self.treeData = res.data;

            self.initTreeNodes();

            if (Object.keys(self.saveObj).length > 0) {
              self.list[0].clickNode = false;
              let id = self.saveObj.ID;
              self.searchNode(item => {
                if (item.ID === id) {
                  if (self.saveObj.getChildren().length > 0) {
                    item.isExpand = self.saveObj.isExpand;
                    item.isFolder = self.saveObj.isFolder;
                  }
                  sendObj = item;
                  return true;
                }
                return false;
              }, 1);
              if (bo) {
                if (Object.keys(sendObj).length === 0) {
                  sendObj = self.list[0];
                  sendObj.clickNode = true;
                }
                self.getItemData(sendObj);
              }
            } else {
              // self.initTreeNodes()
              if (bo) {
                self.getItemData(self.list[0]);
              }
            }

            // setTimeout(function() {

            //     console.log(self.treeData)

            // })
          }
          if (res.code == -1) {
            self.errorMessage({
              action: "confirm",
              title: "警告",
              type: "error",
              list: [],
              isAction: true,
              desc: res.message
            });
          }
        }
      );
    },
    //获取树组件传过来的值
    getItemData(val) {
      this.obj = {};
      // console.log(val.getChildren())
      this.saveObj = val;
      let self = this;
      // console.log(this.saveObj)
      let valID = val.ID.split(".")[1];
      valID = parseInt(valID);
      // console.log(valID)
      if (val.CP_C_ORGUP_ID === null) {
        this.$refs.mytable.getTreeData({});
      } else {
        //当item的TYPE为店仓时
        if (val.TYPE === "CP_C_STORE_ID") {
          this.obj.CP_C_STORE_ID = ["=" + valID];
        }

        //当item的TYPE为供应商时
        // console.log(this.obj)
        //  当item的TYPE为组织时
        if (val.TYPE === "CP_C_HRORG_ID") {
          this.$ajax.dataAjax(
            "/p/cs/usertreequery",
            { CP_C_HRORG_ID: valID },
            function(res) {
              // console.log(res);
              if (res.code === 0) {
                let HRORG = "in ("; //储存键名为CP_C_HRORG_ID对象的ID
                let STORE = "in ("; //储存键名为CP_C_STORE_ID对象的ID

                res.CP_C_HRORG_ID.forEach(item => {
                  HRORG += item.ID + ","; // in 1,2,3,5,6,87,8,6
                });
                // console.log(HRORG)
                res.CP_C_STORE_ID.forEach(item => {
                  STORE += item.ID + ",";
                });
                // console.log(STORE)
                if (res.CP_C_HRORG_ID.length > 0) {
                  self.obj.CP_C_HRORG_ID =
                    HRORG.substring(0, HRORG.length - 1) + ")";
                }
                // console.log(SUPPLIER)
                if (res.CP_C_STORE_ID.length > 0) {
                  self.obj.CP_C_STORE_ID =
                    STORE.substring(0, STORE.length - 1) + ")";
                }
              }
              if (res.code == -1) {
                self.errorMessage({
                  action: "confirm",
                  title: "警告",
                  type: "error",
                  list: [],
                  isAction: true,
                  desc: res.message
                });
              }
            },
            false
          );
        }
        setTimeout(function() {
          self.$refs.mytable.getTreeData(self.obj);
        });
      }
    },

    //获取初始接口传过来的值
    getCstoreorgload() {
      let self = this;

      this.$ajax.dataAjax("/p/cs/userstreeload", {}, function(res) {
        res = JSON.parse(JSON.stringify(res));
        if (res.code === 0) {
          // 储存原始数据以便后续模糊查询使用
          self.ztreeDataSource = JSON.parse(JSON.stringify(res.data));
          //储存渲染树的数据
          self.treeData = res.data;

          self.initTreeNodes();
          // console.log(self.treeData)
          // self.getItemData(self.list[0])
          // for (var index = 0; index < self.nodes.length; index++) {
          //     var node = self.nodes[index];
          //     if (node.xxx != null) {
          //         var parent = node.parent;
          //         while (parent != null) {
          //             parent.isExpand = true;
          //             parent = parent.parent;
          //         }
          //     }
          // }

          // self.list = JSON.parse(JSON.stringify(self.convertTree(self.treeData)))
          //console.log(self.list)
          //console.log(self.convertTree(self.treeData))

          // })
        }
        if (res.code == -1) {
          self.errorMessage({
            action: "confirm",
            title: "警告",
            type: "error",
            list: [],
            isAction: true,
            desc: res.message
          });
        }
      });
    },
    //时时改变list的值
    searchNode(func, b) {
      let self = this;
      let k = 0;
      // this.treeData = JSON.parse(JSON.stringify(this.ztreeDataSource));
      // console.log(typeof this.search)
      // console.log(typeof upper)
      if (!this.search.trim()) return;

      if (typeof func !== "function") {
        let upper = this.search.trim().toUpperCase(); //将输入框的数据转成大写
        if (upper === "") {
          return;
        }
        func = item => item.MIXNAME_UPPER.indexOf(upper) !== -1;
        /*console.log(upper)*/
      }

      let start = Date.now();
      if (b === undefined) {
        this.treeNodes.forEach(item => {
          item.clickNode = false;
          item.isFolder = false;
          item.isExpand = false;
        });
      }
      // for (var i = 0; i < this.treeNodes.length; i++) {
      //     var treeNode = this.treeNodes[i];
      //     treeNode.clickNode = false;
      //     treeNode.isFolder = false;
      //     treeNode.isExpand = false;
      // }
      let end = Date.now();
      /*console.log('A', end - start)*/
      var begin = new Date().getTime();

      // this.treeNodes.forEach(item => {
      //     if (func(item)) {
      //         item.clickNode = true;
      //         var parent = item.parent;
      //         while (parent != null) {
      //             parent.isFolder = true;
      //             parent.isExpand = true;
      //             parent = parent.parent;
      //         }
      //     }
      // });

      for (var i = 0; i < this.treeNodes.length; i++) {
        var treeNode = this.treeNodes[i];
        if (func(treeNode)) {
          // console.log('i',i)
          k++;
          treeNode.clickNode = true;
          var parent = treeNode.parent;
          while (parent != null) {
            // if (parent.children.length < 1000 || b !== undefined){
            parent.isFolder = true;
            parent.isExpand = true;
            // console.log(11)
            // }

            parent = parent.parent;
          }
        }

        if (k >= 100) {
          // console.log(k)
          i = this.treeNodes.length;
        }
      }
      var end1 = new Date().getTime();
      /*console.log('B', end1 - begin)*/
    },

    //搜索框匹配
    handleIconClick() {
      this.searchNode();
    },
    //递归把父节点打开
    openFather(_item) {
      let self = this;
      this.treeData.forEach(item => {
        if (_item.CP_C_ORGUP_ID !== item.ID) {
          return self.treeData;
        }

        // item.clickNode = true;
        item.isFolder = true;
        item.isExpand = true;
        self.openFather(item);
      });
      this.treeData.forEach(item => {
        if (_item.CP_C_STORE_ID !== item.ID) {
          return self.treeData;
        }
        // item.clickNode = true;
        item.isFolder = true;
        item.isExpand = true;
        self.openFather(item);
      });
      //    console.log("why")
    },
    initTree() {
      // 过滤出顶级结点

      this.list = this.treeData.filter(item => item.CP_C_ORGUP_ID == null);
      // this.list[0].clickNode = true;
      // 填充children
      this.list.forEach(item => this.getTreeChildren(item));
    },
    //获取每个子节点的方法
    getTreeChildren(pnode) {
      let self = this;

      pnode.children = this.treeData.filter(
        item => item.CP_C_ORGUP_ID === pnode.ID
      );
      pnode.children.forEach(item => {
        item.lastChild = false;
        pnode.children[pnode.children.length - 1].lastChild = true;
        self.getTreeChildren(item);
      });
    },
    //加载树的方法
    initTreeNodes() {
      // console.log('initTreeNodes')
      var result = this.convertTree(this.treeData);
      if (result.roots[0] !== undefined) {
        result.roots[0].clickNode = true;
      }
      // result.roots[0].clickNode = true;
      this.list = result.roots;
      this.treeNodes = result.nodes;
      // console.log(this.list)
      // this.treeNodes.forEach( item => {
      //     if(item.id === 'CP_C_HRORG.452'){
      //         console.log(item)
      //     }
      // })
      // console.log('item')
    },
    //转化树节点数据
    convertTree(datas) {
      var begin = new Date().getTime();
      var map = {};
      var roots = [];
      var nodes = [];

      function get(id) {
        var n = map[id];
        if (n === undefined) {
          n = {
            ID: id,
            parent: null,
            MIXNAME_UPPER: "",
            isExpand: false,
            isFolder: false,
            clickNode: false,
            lastChild: false
          };
          let children = [];
          n.getChildren = function() {
            return children;
          };

          // Object.defineProperty(n, "lastChild", {
          //     get: function() {
          //         return this.parent && this.parent.children && this.parent.children[this.parent.children.length - 1] == this;
          //     }
          // });
          map[id] = n;
          nodes.push(n);
        }
        return n;
      }

      function node(val) {
        var n = get(val.ID);
        n.CP_C_ORGUP_ID = val.CP_C_ORGUP_ID;
        // n.ECODE = val.ECODE;
        // n.ENAME = val.ENAME;
        n.ID = val.ID;
        // n.ORGTYPE = val.ORGTYPE;
        n.MIXNAME = val.MIXNAME;
        n.MIXNAME_UPPER = val.MIXNAME == null ? "" : val.MIXNAME.toUpperCase();
        // n.RIGHTVALUE = null;
        n.TYPE = val.TYPE;

        if (val.CP_C_ORGUP_ID == null) {
          roots.push(n);
        } else {
          var parent = get(val.CP_C_ORGUP_ID);
          parent.getChildren().push(n);
          // console.log(122)
          n.parent = parent;
        }
        return n;
      }

      for (let index = 0; index < datas.length; index++) {
        node(datas[index]);
      }

      nodes = nodes.concat(roots);

      for (var index = 0; index < nodes.length; index++) {
        var node = nodes[index];
        if (node.getChildren().length > 0) {
          node.getChildren()[node.getChildren().length - 1].lastChild = true;
        }
      }
      var end = new Date().getTime();
      /*console.log(end - begin);*/
      return (window.$test = { roots, map, nodes, vm: this });
    },

    searchData() {
      this.$refs.mytable.getTreeData(this.obj);
    }
  }
};
</script>


<style lang="less" type="text/less">
.myTree {
  height: 100%;
  display: flex;
  position: relative; // padding: 10px 0;
  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
    background-color: #f5f5f5;
  }
  /*定义滚动条的轨道，内阴影及圆角*/
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    background-color: #f5f5f5;
  }
  /*定义滑块，内阴影及圆角*/
  ::-webkit-scrollbar-thumb {
    /*width: 10px;*/
    height: 20px;
    border-radius: 6px;
    -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
    background-color: #aaa;
  }
}

//左边一整块结构
.leftHao {
  width: 240px;
  /*height: 100%;*/
  position: relative;
  overflow-y: auto;
}

//搜索框
//左边的树结构
.leftTree {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  margin-top: 44px;
}

//右边的表格
.rightTable {
  flex: 1;
  overflow: auto;
  margin-left: 10px;
}

//分割线
// .LineBetween{
// 	width: 1px;
// 	height: 100%;
// 	background-color: #d2d2d2;
// 	position: absolute;
// 	top: 0px;
// 	left: 240px;
// }
.LineBetween {
  position: absolute;
  top: 0px;
  left: 240px;
  width: 1px;
  height: 100%;
  background-color: #d2d2d2;
  box-sizing: border-box;
}

.tree {
  // padding: 0 10px 0 0px;
  // box-sizing: border-box;
  height: 100%; // padding-top: 10px;
}

//搜索框
.leftHao .el-input {
  //  float: left;
  /*height: 24px;*/
  width: 220px;
  margin-top: 10px; // margin-bottom: 10px;
  margin-right: 10px;

  .el-input__inner {
    border-radius: 2px;
    height: 24px;
    border: 1px solid #d2d2d2;
    font-size: 12px;
    padding-left: 5px;
    padding-right: 30px;
  }
  .el-input__icon {
    cursor: pointer;
    top: 5px;
  }
  .el-input__inner:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: rgba(87, 87, 87, 0.3);
  }
  .el-input__inner::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: rgba(87, 87, 87, 0.3);
  }
  .el-input__inner:-ms-el-input-placeholder {
    color: rgba(87, 87, 87, 0.3);
  }
  .el-input__inner::-webkit-el-input-placeholder {
    color: rgba(87, 87, 87, 0.3);
  }
  .el-input__inner:focus {
    border-color: #0f8ee9;
  }
  .el-icon-search {
    right: -3px;
  }
}

//给label设置140px的宽度
.myTree .el-form--inline .el-form-item__content {
  width: 140px;
}

//输入框131px 设置9px的padding值
.myTree
  .tableList
  .searchList
  .demo-form-inline
  > div.el-form-item
  input[type="text"] {
  padding-right: 9px;
}

//每个小块输入整体间距为56px
.myTree .tableList .searchList .demo-form-inline > div.el-form-item {
  // margin-right: 56px;
  width: 33%;
}
</style>
